import { Component } from '@angular/core';

@Component({
  selector: 'studio-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {}
